import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { ClipboardService } from '../../../../../core/services/clipboard.service';
import { InputsModule } from '../../inputs.module';
import { ITextInput } from '../../interface';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'input-text',
    templateUrl: './text.component.html',
    styleUrl: './text.component.scss',
    imports: [InputsModule, InlineSVGModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class InputTextComponent extends BaseInputComponent<ITextInput> {
  constructor(private clipboardService: ClipboardService) {
    super();
  }

  async paste() {
    this.options.control?.setValue(await this.clipboardService.value());
  }
}
